import PropTypes from 'prop-types'
import React from 'react'

const AdminWorkspaceOutline24 = ({
   className,
   color,
   height,
   strokeWidth,
   width
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         strokeLinecap="square"
         strokeLinejoin="miter"
         strokeWidth={strokeWidth}
         fill={color}
         stroke={color}>
         <rect height="20" width="20" fill="none" x="2" y="2" />
         <line fill="none" x1="16" x2="16" y1="12" y2="18" />
         <line fill="none" x1="16" x2="16" y1="6" y2="8" />
         <line fill="none" x1="18" x2="14" y1="8" y2="8" />
         <line fill="none" x1="8" x2="8" y1="6" y2="12" />
         <line fill="none" x1="8" x2="8" y1="16" y2="18" />
         <line fill="none" x1="10" x2="6" y1="16" y2="16" />
      </g>
   </svg>
)

AdminWorkspaceOutline24.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

AdminWorkspaceOutline24.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(AdminWorkspaceOutline24)
